import { Badge } from '@ui/themed';
import { t } from 'i18next';
import { CUSTOMER_ROLE_TYPE, CUSTOMER_STANDARD_ROLES } from '../constants';
import type { CustomerRole } from '../types/role';

export function RoleBadge({ role }: { role: CustomerRole }) {
  switch (role.slug) {
    case CUSTOMER_STANDARD_ROLES.MAIN:
      return <Badge variant="green">{t('features:customers.common.role.main')}</Badge>;
    case CUSTOMER_STANDARD_ROLES.LIMITED:
      return <Badge variant="orange">{t('features:customers.common.role.limited')}</Badge>;
    case CUSTOMER_STANDARD_ROLES.SALES_AGENT:
      return <Badge variant="purple">{t('features:customers.common.role.sales_agent')}</Badge>;
    case CUSTOMER_STANDARD_ROLES.SALES_ADMIN:
      return <Badge variant="blue">{t('features:customers.common.role.sales_admin')}</Badge>;
  }
  return (
    <Badge variant={role.type === CUSTOMER_ROLE_TYPE.SALES ? 'orange' : 'default'}>
      {role.name}
    </Badge>
  );
}
